export default __webpack_public_path__ + "6d41e1dbf6834eb7902ae32a592ec0c7.png";